import { FC, PropsWithChildren } from 'react';
import { FiX } from 'react-icons/fi';
import { merge } from '../../utils/utility';
import { Modal } from './Modal';

interface Props extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  className?: string;
  title: string;
}

export const ModalWithHeader: FC<Props> = ({ open, onClose, children, className, title }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={merge(className, 'p-6 flex flex-col gap-3')}>
        <div className="flex w-full items-center">
          <div className="flex-1 text-primary-800 text-xl font-semibold font-primary">{title}</div>
          <button type="button" onClick={onClose}>
            <FiX className="h-6 w-6 text-primary-800" />
          </button>
        </div>
        <div className="flex-1">{children}</div>
      </div>
    </Modal>
  );
};
